// Utils
import { getStartOfDayDate, TIMES } from '../utils/timeUtil';

// Constants
import { REMINDER_VALUES } from './reminderConstants';

const getTimestampAt9amOn = (daysBefore: number) => (date: Date): number => {
    const updatedDate = getStartOfDayDate(date);
    updatedDate.setHours(9);
    updatedDate.setDate(updatedDate.getDate() - daysBefore);
    return updatedDate.getTime();
};

const getTimestampAt9amOnDay = getTimestampAt9amOn(0);
const getTimestampAt9amOnDayBefore = getTimestampAt9amOn(1);

export const getTimestampForReminder = ({
    dueDate,
    dueReminder,
}: {
    dueDate: number | null | undefined;
    dueReminder: string | null | undefined;
}): number | null => {
    if (!dueDate) return null;

    const date = new Date(dueDate);

    const dueDateTimestamp = date.getTime();

    switch (dueReminder) {
        case REMINDER_VALUES.WHEN_DUE:
            return dueDateTimestamp;
        case REMINDER_VALUES.TEN_MINUTES_BEFORE:
            return dueDateTimestamp - 10 * TIMES.MINUTE;
        case REMINDER_VALUES.ONE_HOUR_BEFORE:
            return dueDateTimestamp - TIMES.HOUR;
        case REMINDER_VALUES.NINE_AM_DAY_OF:
            return getTimestampAt9amOnDay(date);
        case REMINDER_VALUES.NINE_AM_DAY_BEFORE:
            return getTimestampAt9amOnDayBefore(date);
        case REMINDER_VALUES.NONE:
        default:
            return null;
    }
};
